import {
  Workbook,
  type Border,
  type Cell,
  type Row,
  type Worksheet,
} from 'exceljs';
import type { AdminLeadRow } from '../services/leads.service';

function applyThinBordersToAllCells(sheet: Worksheet) {
  const side: Border = {
    style: 'thin',
    color: { argb: 'FF333333' },
  };

  sheet.eachRow({ includeEmpty: false }, (row: Row, _rowNumber: number) => {
    row.eachCell({ includeEmpty: true }, (cell: Cell, _colNumber: number) => {
      cell.border = {
        top: side,
        left: side,
        bottom: side,
        right: side,
      };
    });
  });
}

export async function downloadVehicleLeadsExcel(rows: AdminLeadRow[]): Promise<void> {
  const workbook = new Workbook();
  workbook.creator = 'Toyota Lanka Intranet';
  const sheet = workbook.addWorksheet('Vehicle Leads', {
    views: [{ state: 'frozen', ySplit: 1 }],
  });

  const headers = [
    'Submitted',
    'Submitter name',
    'Submitter emp no',
    'Submitter branch',
    'Submitter phone',
    'Customer name',
    'Customer phone',
    'Suggested branch',
    'Suggested model',
    'Comments',
    'Lead ID',
  ];

  sheet.addRow(headers);
  const headerRow = sheet.getRow(1);
  headerRow.font = { bold: true };
  headerRow.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
  headerRow.height = 22;

  for (const row of rows) {
    const sb = row.submittedBy;
    sheet.addRow([
      row.createdAt,
      sb?.fullName ?? '',
      sb?.empNo ?? '',
      sb?.branch ?? '',
      sb?.telNo ?? '',
      row.customerName,
      row.customerPhone,
      row.suggestedBranch,
      row.suggestedModel,
      row.otherComments ?? '',
      row.id,
    ]);
  }

  const colWidths = [22, 26, 14, 22, 14, 22, 14, 20, 22, 40, 38];
  colWidths.forEach((w, i) => {
    sheet.getColumn(i + 1).width = w;
  });

  sheet.eachRow({ includeEmpty: false }, (row: Row, rowNumber: number) => {
    if (rowNumber > 1) {
      row.alignment = { vertical: 'top', wrapText: true };
    }
  });

  applyThinBordersToAllCells(sheet);

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const d = new Date();
  const stamp = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `vehicle-leads-${stamp}.xlsx`;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
